import { css } from "@emotion/react";
import TxtWithScroll from "../atoms/TxtWithScroll";

const Info0705: React.FC = () => {
  return (
    <div css={infoStyle}>
      <div css={dateStyle}>2023/07/05</div>
      <div>本サイトをオープンしました。</div>
    </div>
  );
};

const Info0712: React.FC = () => {
  return (
    <div css={infoStyle}>
      <div css={dateStyle}>2023/07/12</div>
      <div>キャスト、スタッフを追加しました。</div>
    </div>
  );
};

const Info0720: React.FC = () => {
  return (
    <div css={infoStyle}>
      <div css={dateStyle}>2023/07/20</div>
      <div>予告動画を追加しました。</div>
    </div>
  );
};

const Info0801_goods: React.FC = () => {
  return (
    <div css={infoStyle}>
      <div css={dateStyle}>2023/08/01</div>
      <div>グッズ情報を更新しました。</div>
    </div>
  );
};

const Info0801_kusakawa: React.FC = () => {
  return (
    <div css={infoStyle}>
      <div css={dateStyle}>2023/08/01</div>
      <div>
        <a
          href="https://www.culture-pub.jp/news/363/"
          target="_blank"
          rel="noopener noreferrer"
          css={linkStyle}
        >
          8/6昼公演に草川拓弥（超特急）カメオ出演決定！
        </a>
      </div>
    </div>
  );
};

const Info0801_campaign: React.FC = () => {
  return (
    <div css={infoStyle}>
      <div css={dateStyle}>2023/08/01</div>
      <div>
        <a
          href="https://www.culture-pub.jp/news/361/"
          target="_blank"
          rel="noopener noreferrer"
          css={linkStyle}
        >
          8/6公演のリピーター観劇プレゼントキャンペーンについて
        </a>
      </div>
    </div>
  );
};

const Info0803: React.FC = () => {
  return (
    <div css={infoStyle}>
      <div css={dateStyle}>2023/08/03</div>
      <div>チケット情報を更新しました。</div>
    </div>
  );
};

const primaryColor = "#DD6B74";

const linkStyle = css`
  color: ${primaryColor};
`;

const infoStyle = css`
  padding-bottom: 8pt;
  font-size: 14px;
  text-align: left;
`;
const dateStyle = css`
  padding-bottom: 1pt;
`;

const LatestInfos: React.FC = () => {
  return (
    <div css={mainStyle} id="news">
      <div css={contentsWrapper}>
        <div css={upperTitleWrapperStyle}>
          <div css={borderStyle}></div>
          <div css={titleStyle}>最新情報</div>
          <div css={borderStyle}></div>
        </div>
        <div css={txtScrollWrapperStyle}>
          <TxtWithScroll width={350} height={140}>
            <Info0803 />
            <Info0801_kusakawa />
            <Info0801_campaign />
            <Info0801_goods />
            <Info0720 />
            <Info0712 />
            <Info0705 />
          </TxtWithScroll>
        </div>
        <div css={bottomBorderWrapperStyle}>
          <div css={borderStyle}></div>
        </div>
      </div>
    </div>
  );
};

const mainStyle = css`
  width: 100%;
  height: 200px;
  background-color: #fdf4f4;
  display: flex;
  justify-content: center;
  overflow: hidden;
`;

const contentsWrapper = css`
  width: 100%;
  max-width: 500px;
  padding: 10px 20px;
`;

const upperTitleWrapperStyle = css`
  display: flex;
  align-items: center;
`;

const bottomBorderWrapperStyle = css`
  display: flex;
  align-items: center;
`;

const borderStyle = css`
  height: 1px;
  background-color: ${primaryColor};
  flex-grow: 1;
`;

const titleStyle = css`
  margin: 0 10px;
  font-size: 12pt;
  font-weight: 500;
`;

const txtScrollWrapperStyle = css`
  z-index: 1;
  position: relative;
  display: flex;
  justify-content: center;
`;

export default LatestInfos;
